import axios from 'axios';
import authService from './authService';
import { API_URL } from '@/config/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

api.interceptors.request.use(
  (config) => {
    const token = authService.token.get();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
    }
    return Promise.reject(error);
  }
);

const baseEndpoint = '/lau-checks';

export default {
  criar(dados) {
    return api.post(baseEndpoint, dados);
  },

  listar(apenasAtivos = true) {
    return api.get(baseEndpoint, { params: { apenasAtivos } });
  },

  atualizar(id, dados) {
    return api.put(`${baseEndpoint}/${id}`, dados);
  },

  desativar(id) {
    return api.delete(`${baseEndpoint}/${id}`);
  },

  listarHoje() {
    return api.get(`${baseEndpoint}/hoje`);
  },

  listarDia(data) {
    return api.get(`${baseEndpoint}/dia`, { params: { data } });
  },

  registrar(id, dados) {
    return api.post(`${baseEndpoint}/${id}/registros`, dados);
  },

  listarRegistros(id, inicio, fim) {
    const params = {};
    if (inicio) params.inicio = inicio;
    if (fim) params.fim = fim;
    return api.get(`${baseEndpoint}/${id}/registros`, { params });
  },

  dashboard(inicio, fim) {
    const params = {};
    if (inicio) params.inicio = inicio;
    if (fim) params.fim = fim;
    return api.get(`${baseEndpoint}/dashboard`, { params });
  },

  dashboardUsuarios(inicio, fim) {
    const params = {};
    if (inicio) params.inicio = inicio;
    if (fim) params.fim = fim;
    return api.get(`${baseEndpoint}/dashboard/usuarios`, { params });
  },
};
